import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { CardShell } from '@shared/ui/CardShell';
import { LawsuitCard } from './LawsuitCard';

/**
 * Полноценная страница карточки иска по URL
 * `/agents/statut/lawsuits/:id`. Параллельная архитектура к ClaimPage —
 * URL-based, история браузера работает, deep link шарится между юристами.
 *
 * `onBack` возвращает на реестр исков (вкладка «Иски» в /claims).
 */
export function LawsuitPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!id) {
    return <Navigate to="/agents/statut/claims?tab=lawsuits" replace />;
  }

  const back = () => navigate('/agents/statut/claims?tab=lawsuits');

  return (
    <CardShell title="Карточка иска" onBack={back}>
      <LawsuitCard lawsuitId={id} onClose={back} />
    </CardShell>
  );
}
